import { Box, Modal } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

const StyledLoader = styled(Box)`
  @keyframes spin {
    0% {
      transform: rotate(0deg) translateZ(0);
    }
    100% {
      transform: rotate(360deg) translateZ(0);
    }
  }

  border: 5px solid ${props => props.theme.colors.accent};
  border-top: 5px solid ${props => props.theme.colors.primary};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.8s linear infinite;
  will-change: transform;
`

const StyledModal = styled(Modal)`
  display: flex;
  justify-content: center;
  padding-top: 12rem;
  background-color: ${props => props.theme.colors.shadowXSmall};
  backdrop-filter: blur(1.2px);
`
type Props = {
  loading: boolean
}

export const ThemeModal = (props: Props) => {
  const { loading } = props
  return (
    <StyledModal open={loading}>
      <StyledLoader />
    </StyledModal>
  )
}
